import React, { useState } from 'react'
import { IoFilter } from "react-icons/io5";
import { HiDotsVertical } from "react-icons/hi";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoIosArrowDown } from 'react-icons/io';
import { FaArrowLeftLong } from 'react-icons/fa6';
import "./Journals.scss"
import { useNavigate } from 'react-router-dom';
import { FaPaperclip } from "react-icons/fa6";
import { PiTextBLight, PiTextStrikethrough, PiTextUnderline } from "react-icons/pi";
import { PiTextItalic } from "react-icons/pi";



const journalData: Journal[] = [
  {
    emoji: "🙏",
    emojiName: "Thankful",
    date: "2025-09-17",
    time: "08:30 AM",
    description: "Felt grateful for the small wins today, especially completing my tasks on time.",
    images: ["/images/Attachment1.jpg", "/images/Attachment2.jpg"],
    distracted: "I got distracted by social media notifications and incoming emails, but I managed to refocus after short breaks."
  },
  {
    emoji: "🤩",
    emojiName: "Excited",
    date: "2025-09-16",
    time: "10:00 AM",
    description: "Had an exciting breakthrough in my project, feeling very motivated!",
    images: ["/images/Attachment1.jpg", "/images/Attachment2.jpg"],
    distracted: "Small interruptions from colleagues asking questions and random Slack messages, but I stayed motivated and returned quickly to my work."
  },
  {
    emoji: "😀",
    emojiName: "Happy",
    date: "2025-09-15",
    time: "07:45 AM",
    description: "Today was a happy day, spent quality time with friends.",
    images: ["/images/Attachment1.jpg", "/images/Attachment2.jpg"],
    distracted: "Minor distractions from background noise and my phone, but they didn’t affect my overall happiness."
  },
  {
    emoji: "🙏",
    emojiName: "Thankful",
    date: "2025-09-14",
    time: "09:15 AM",
    description: "Feeling thankful for the support I received from my team.",
    images: ["/images/Attachment1.jpg", "/images/Attachment2.jpg"],
    distracted: "Several short calls and messages from team members distracted me, but I was able to organize my tasks efficiently afterward."
  },
  {
    emoji: "😢",
    emojiName: "Sad",
    date: "2025-09-13",
    time: "06:50 PM",
    description: "Felt a bit sad after a minor misunderstanding, but learning from it.",
    images: ["/images/Attachment1.jpg", "/images/Attachment2.jpg"],
    distracted: "I kept thinking about the misunderstanding, which affected my focus and productivity for a while."
  },
  {
    emoji: "😡",
    emojiName: "Angry",
    date: "2025-09-12",
    time: "03:30 PM",
    description: "Frustrated with the unexpected delays in my work today.",
    images: ["/images/Attachment1.jpg", "/images/Attachment2.jpg"],
    distracted: "Technical glitches and unexpected delays in the project really disrupted my workflow, making me feel impatient and irritated."
  },
  {
    emoji: "😌",
    emojiName: "Relaxed",
    date: "2025-09-18",
    time: "08:00 PM",
    description: "Feeling relaxed after a calm evening and some meditation.",
    images: ["/images/Attachment1.jpg", "/images/Attachment2.jpg"],
    distracted: "Today I felt more focused after practicing deep breathing. I noticed fewer distractions while working and managed to complete my top-priority tasks. I plan to start tomorrow with meditation to maintain focus and reduce interruptions from emails and notifications."
  },
  {
    emoji: "😀",
    emojiName: "Happy",
    date: "2025-09-15",
    time: "07:45 AM",
    description: "Today was a happy day, spent quality time with friends.",
    images: ["/images/Attachment1.jpg", "/images/Attachment2.jpg"],
    distracted: "A few small interruptions from phone notifications occurred, but I quickly refocused on spending quality time and enjoying the moment."
  },
  {
    emoji: "🙏",
    emojiName: "Thankful",
    date: "2025-09-14",
    time: "09:15 AM",
    description: "Feeling thankful for the support I received from my team.",
    images: ["/images/Attachment1.jpg", "/images/Attachment2.jpg"],
    distracted: "Notifications from messaging apps and a few unplanned calls briefly broke my concentration, but I stayed positive and thankful."
  },
  {
    emoji: "😢",
    emojiName: "Sad",
    date: "2025-09-13",
    time: "06:50 PM",
    description: "Felt a bit sad after a minor misunderstanding, but learning from it.",
    images: ["/images/Attachment1.jpg", "/images/Attachment2.jpg"],
    distracted: "Thinking repeatedly about the misunderstanding distracted me from my tasks, and I had to take a short walk to regain focus."
  },
  {
    emoji: "😡",
    emojiName: "Angry",
    date: "2025-09-12",
    time: "03:30 PM",
    description: "Frustrated with the unexpected delays in my work today.",
    images: ["/images/Attachment1.jpg", "/images/Attachment2.jpg"],
    distracted: "Unexpected interruptions, including last-minute requests and technical issues, slowed my progress and made it hard to stay calm."
  },
];

interface Journal {
  emoji: string;
  emojiName: string;
  date: string;
  time: string;
  description: string;
  images: string[];
  distracted: string;
}

function Journals() {

  const navigate = useNavigate();


  const [viewJournal, setViewJournal] = useState<boolean>(false)
  const [selectedJournal, setSelectedJournal] = useState<Journal | null>(null);
  const [openImg, setOpenImg] = useState<boolean>(false)

  return (
    <div className="Journals">
      {!viewJournal && !selectedJournal && (
        <div className="Journals_section">
          <p className="journals_prompt">What did you learn from today’s lesson?</p>

          <div className="journals_add_section">
            <div className="journals_textarea">
              <textarea id="journalInput" placeholder='What’s going on in your head right now?'></textarea>
            </div>
            <div className="journals_toolbar">
              <FaPaperclip />
              <PiTextBLight />
              <PiTextItalic />
              <PiTextUnderline />
              <PiTextStrikethrough />
              <img src="./images/TextSubscript.svg" alt="TextSubscript" />
              <img src="./images/TextSuperscript.svg" alt="TextSuperscript" />
              <select className=''>
                <option value="">Arial</option>
                <option value="">Arial</option>
                <option value="">Arial</option>
              </select>
              <select className=''>
                <option value="">16</option>
                <option value="">17</option>
                <option value="">18</option>
              </select>
              <select className=''>
                <option value="excited">Excited 🤩</option>
                <option value="happy">Happy 😀</option>
                <option value="sad">Sad 😢</option>
                <option value="angry">Angry 😡</option>
                <option value="thankful">Thankful 🙏</option>
                <option value="relaxed">Relaxed 😌</option>
              </select>
              <button className='save'>Save</button>
            </div>
          </div>


          <div className="journals_recent_header">
            <p className="journals_recent_title">Your Recent Journals</p>
            <button
              onClick={() => {
                setViewJournal(true);
                navigate("/journal", { state: { courseTitle: "Your Journal Collection" } })

              }}
              className="journals_view_all_btn"
            >
              View all
            </button>
          </div>

          <div className="Journals_card_slice">
            <div className="Journals_cards">
              {journalData.slice(0, 3).map((journal, index) => (
                <div
                  key={index}
                  onClick={() => {
                    setSelectedJournal(journal);
                    navigate("/journal", { state: { courseTitle: "Your Journal Collection" } })

                  }}
                  className="journal_card"
                >
                  <div className="journal_header_card">
                    <p className="journal_emoji">{journal.emoji}</p>
                    <HiDotsVertical className="journal_options_icon" />
                  </div>
                  <div className="journal_datetime">
                    <p className="journal_date">{journal.date} .</p>
                    <p className="journal_time">{journal.time}</p>
                  </div>
                  <p className="journal_description">{journal.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {viewJournal && !selectedJournal && (
        <div className="your_journal">
          <div className="journal_header">
            <div className="journal_title">
              <p className="main_title">Your Journal Collection</p>
              <p className="sub_title">
                Revisit your past reflections and track personal growth.
              </p>
            </div>
            <div className="journal_filters">
              <select className="filter_select">
                <option value="excited">Excited 🤩</option>
                <option value="happy">Happy 😀</option>
                <option value="sad">Sad 😢</option>
                <option value="angry">Angry 😡</option>
                <option value="thankful">Thankful 🙏</option>
                <option value="relaxed">Relaxed 😌</option>
              </select>
              <button className="filter_btn">
                <IoFilter />
                <span>Filters</span>
              </button>
            </div>
          </div>
          <div className="Journals_cards">
            {journalData.map((journal, index) => (
              <div
                key={index}
                className="journal_card"
                onClick={() => {
                  setSelectedJournal(journal);
                  navigate("/journal", { state: { courseTitle: "Your Journal Collection" } })
                }}
              >
                <div className="journal_header_card">
                  <p className="journal_emoji">{journal.emoji}</p>
                  <HiDotsVertical />
                </div>
                <div className="journal_datetime">
                  <p className="journal_date">{journal.date} .</p>
                  <p className="journal_time">{journal.time}</p>
                </div>
                <p className="journal_description">{journal.description}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      {selectedJournal && (
        <div className="journal_detail">
          <p
            className="back_btn"
            onClick={() => {
              setSelectedJournal(null);
              setViewJournal(true);
            }}
          >
            <FaArrowLeftLong />
          </p>

          <div className="journal_header_card">
            <div className="journal_emojinamedate">
              <p className="journal_emoji">{selectedJournal.emoji}</p>
              <p className="journal_emoji_name">{selectedJournal.emojiName}</p>
              <p className="journal_datetime">
                {selectedJournal.date} · {selectedJournal.time}
              </p>
            </div>
            <RiDeleteBin5Line />
          </div>

          <div className="journal_distracted">
            <p className="distracted_title">What distracted me today?</p>
            <p className="distracted_text">{selectedJournal.distracted}</p>
          </div>

          <hr className="line" />

          <div className="journal_attachments">
            <div
              className="attachments_header"
              onClick={() => setOpenImg(!openImg)}
            >
              <IoIosArrowDown className={`arrow_icon ${openImg ? "open" : ""}`} />
              <p>Attachments </p>
              <p className="count">{selectedJournal.images.length}</p>
            </div>

            {openImg && selectedJournal.images.length > 0 && (
              <div className="journal_images">
                {selectedJournal.images.map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    className="journal_image"
                    alt={`attachment-${i}`}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Journals